import { QuestionnaireAnswersDto } from '../jobOffers/jobOffers.dto';
import { ErrorState } from '../_commons/state.common';
import { SubmitJobApplicationCommandError } from './jobOfferApplication.thunk';

export const initialState: JobOfferApplicationState = {
    answers: {
        additionalQuestionnaireAnswers: []
    },
    error: null,
    formErrors: []
};

export interface JobOfferApplicationState {
    answers: QuestionnaireAnswersDto;
    error: ErrorState;
    formErrors: SubmitJobApplicationCommandError[];
}
